import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import DialogServices from '../services/dialog.service';
import { ModalInsuranceAttentionComponent } from '../components/modal-insurance-attention/modal-insurance-attention.component';

@Injectable({ providedIn: 'root' })
export default class InsuranceService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private dialogServices: DialogServices = inject(DialogServices);
	
	getPolicy(policyId, onSuccess, onError) {
		this.httpClient.get(this.config.getRestUrl() + 'insurance/api/v1/policy/' + policyId + '/policy.pdf', { withCredentials: true })
			.toPromise().then(onSuccess).catch(onError);
	}
	
	openInsuranceAttentionRequiredModal(incompletePolicy, successCallback?, errorCallback?) {
		var dialog = this.dialogServices.show({
			controller: ModalInsuranceAttentionComponent,
			incompletePolicy: incompletePolicy,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
		dialog.afterClosed().subscribe(
			(incompletePolicy) => {
				if (typeof successCallback === "function") successCallback(incompletePolicy);
			},
			() => {
				if (typeof errorCallback === "function") errorCallback();
			}
		);
	}
	
}